import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { Router } from '@angular/router';
import { AppService } from '../../app.service';
import { DocLibraryVM, GETDocStatus, GETDocTpe, GETModels } from '../GET_NEW_UI/entities/global/model';
import { DocumentLibraryService } from '../GET_NEW_UI/services/document-library.service';
import { PreferencesService } from '../preferences/preferences.service';
import { MY_FORMATS } from '../rope-shovel/pages/rope-shovel-inspection/rope-shovel-inspection.component';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';

@Component({
  selector: 'app-document-in-library-search',
  templateUrl: './document-in-library-search.component.html',
  styleUrls: ['./document-in-library-search.component.scss'],
  providers: [
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'en-au' }
  ],
})
export class DocumentInLibrarySearchComponent implements OnInit {

  constructor( private _appService: AppService, private _router:Router,
    private _documentLibraryService:DocumentLibraryService,
    private readonly _pref: PreferencesService,) { }
      
  modelList:GETModels[]=[]
  modelList_:GETModels[]=[]
  CopymodelList:GETModels[]=[]
  docTypeList:GETDocTpe[]=[]
  docStatusList:GETDocStatus[]=[]

  SearchResultsList:DocLibraryVM[]=[];
 
  DocumentID:number
  Selectmodel:number[]=[]
  InputSelectmodel:string
  serialStart:string
  serialEnd:string
  docTypeID:number
  docHeading:string
  docNumber:string
  docRev:string
  docStatus:number
  startDate:Date;
  endDate:Date;


  ngOnInit() {
    this._appService.setPageTitle('Search Document in Library');
    this.getGETModels();
    this. getGETDocType();
    this. getGETDocStatus();
  }

  NavigateToDocumentLibraryComponent(){
   // this._router.navigate(['/document-library']);
   this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
    if(res=="True"){
      this._router.navigate(['/document-library']);
    }else{             
      window.open('/document-library/', '_blank');
     
    }
});

  }



  onClickOpenForm(row:DocLibraryVM) {
    if (row.Id) {
      //this._router.navigate(['/editdigitalformscomponent', form.Id]);
     // window.open('/document-library/' + row.Id, '_blank');

     this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
      if(res=="True"){
        this._router.navigate(['/document-library', row.Id]);
      }else{             
        window.open('/document-library/' + row.Id, '_blank');
       
      }
  });


    } else {
      //this._router.navigate(['/uploadformedit', form.Id]);
     // window.open('/document-library/');

    }
  }

  getGETModels()
  {
    this._documentLibraryService.GetGETModelList().subscribe(res=>{
    this.modelList=res
    this.CopymodelList=res
    })
  }

  
  getGETDocType()
  {
    this._documentLibraryService.GetGETDocType().subscribe(res=>{
    this.docTypeList=res
    })
  }

  
  getGETDocStatus()
  {
    this._documentLibraryService.GetGEDocStatus().subscribe(res=>{
    this.docStatusList=res
    })
  }

  RestFields(){
    this.docTypeID=0;
    this.Selectmodel =[];
    this.docNumber="";
    this.startDate=null;
    this.endDate=null;
    this.serialStart="";
    this.serialEnd="";
    this.docRev="";
    this.docHeading="";
    this.docStatus=0;
    this.SearchResultsList=[];
    this.endDate=null;
    this.startDate = null
    this.InputSelectmodel=""
    this.modelList = this.CopymodelList

  }

  SeachDocs(){
    let model=new DocLibraryVM();
    let array=[];
     this.Selectmodel.length>0?array=this.Selectmodel:array;
     model.ModelId = array;
     model.DocTypeId =this.docTypeID==undefined?0:this.docTypeID;
     model.DocNo=this.docNumber==undefined?"":this.docNumber;
     model.StartDate=this.startDate==undefined?null:this.startDate;
     model.EndDate=this.endDate==undefined?null:this.endDate;
     model.SerialStart=this.serialStart==undefined?"":this.serialStart;
     model.SerialEnd=this.serialEnd==undefined?"":this.serialEnd;
     model.DocRevNo=this.docRev==undefined?"":this.docRev;
     model.DocHeading=this.docHeading==undefined?"":this.docHeading;
     model.DocStatusId=this.docStatus==undefined?0:this.docStatus;

     console.log("search fileds", model)

     this._documentLibraryService.SearchDocumnetLibraries(model).subscribe(res=>{
     console.log("resukt", res)
     this.SearchResultsList = res

     })
  }

    
  changeModelAutoComplete(event){
    const filterValue = event.target.value.toLowerCase();
 
    this.modelList = this.CopymodelList.filter(option => option.modelName.toLowerCase().includes(filterValue));
  }
  
  
   getTitle(UserId: number) {
    return this.modelList.find(u => u.ID === UserId).modelName;
  }


  onSelectBuildNO(value) {
    this.Selectmodel=[]
    
    if(value!=undefined){
      this.modelList_=this.modelList.filter(f=>f.modelName==value)
        console.log("t", value)
        let val= this.modelList_[0].ID
       this.Selectmodel.push(val) 
    }
  }
}
